export enum LinkAttributes {
  relNoFollow = 'nofollow',
  targetBlank = '_blank',
}
